import { authUserSchema, loginResponseSchema, type AuthUser, type LoginInput } from '@plane/shared';
import { z } from 'zod';

import { apiRequest, setAccessToken } from '@/services/http-client';

/**
 * Chamadas de autenticação.
 *
 * O refresh token nunca passa por aqui: ele vive no cookie httpOnly e o
 * navegador o envia sozinho por causa do `credentials: 'include'`.
 */

export async function login(input: LoginInput): Promise<AuthUser> {
  const resposta = await apiRequest('/api/v1/auth/login', loginResponseSchema, {
    method: 'POST',
    body: JSON.stringify(input),
  });

  setAccessToken(resposta.accessToken);

  return resposta.user;
}

export function fetchCurrentUser(): Promise<AuthUser> {
  return apiRequest('/api/v1/auth/me', authUserSchema);
}

export async function logout(): Promise<void> {
  try {
    await apiRequest('/api/v1/auth/logout', z.void(), { method: 'POST' });
  } finally {
    // O token some da memória mesmo que a chamada falhe: sair tem de funcionar
    // com a API fora do ar. O cookie fica, mas sem access token o painel não
    // faz nada, e a próxima renovação encontra a sessão revogada ou expirada.
    setAccessToken(null);
  }
}
